/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdminCompanyCreateInput } from "../../entities/models/AdminCompanyCreateInput";
import { z } from "zod/v4";

export const modelsAdminCompanyCreateInputSchema = z.object({
    "address": z.optional(z.string()),
"currency": z.optional(z.string()),
"info": z.optional(z.object({
    
    }).catchall(z.any())),
"inn": z.optional(z.string()),
"kpp": z.optional(z.string()),
"name": z.string(),
"phone": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsAdminCompanyCreateInput>